import React, { useEffect, useState } from "react";
import { useParams, Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import VoucherCard from "../components/VoucherCard";
import { Filter } from "lucide-react";

export default function CategoryPage() {
    const { name } = useParams();
    const decoded = decodeURIComponent(name || "all");
    const [params, setParams] = useSearchParams();
    const [items, setItems] = useState([]);
    const [total, setTotal] = useState(0);
    const [cats, setCats] = useState([]);
    const [busy, setBusy] = useState(false);
    const sort = params.get("sort") || "featured";

    useEffect(() => {
        api.get("/api/brands/categories").then((r) => setCats(r.data.categories));
    }, []);
    useEffect(() => {
        setBusy(true);
        const p = new URLSearchParams();
        if (decoded !== "all") p.set("category", decoded);
        p.set("sort", sort);
        p.set("limit", "60");
        api.get(`/api/rewards?${p.toString()}`).then((r) => {
            setItems(r.data.rewards);
            setTotal(r.data.total);
            setBusy(false);
        });
    }, [decoded, sort]);

    return (
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-6">
            <div className="flex items-center gap-2 text-xs text-[#6b7280] mb-2">
                <Link to="/" className="hover:text-[#0b1437]">Home</Link>
                <span>/</span>
                <span className="text-[#0b1437] font-semibold">{decoded === "all" ? "All deals" : decoded}</span>
            </div>
            <h1 className="font-display text-3xl md:text-4xl font-bold">
                {decoded === "all" ? "All deals" : decoded}
            </h1>
            <p className="text-[#6b7280] text-sm mt-1">{total} gift cards & vouchers • Points + Cash</p>

            <div className="mt-5 flex flex-wrap gap-2 items-center">
                <Link
                    to="/category/all"
                    className={`px-3 py-1.5 rounded-full text-sm ${
                        decoded === "all" ? "bg-[#c9a959] text-black font-semibold" : "bg-[#f9fafb] text-[#374151] border border-[rgba(11,20,55,0.10)]"
                    }`}
                >
                    All <span className="opacity-60">({cats.reduce((s, c) => s + c.count, 0)})</span>
                </Link>
                {cats.map((c) => (
                    <Link
                        key={c.name}
                        to={`/category/${encodeURIComponent(c.name)}`}
                        data-testid={`catchip-${c.name}`}
                        className={`px-3 py-1.5 rounded-full text-sm ${
                            decoded === c.name
                                ? "bg-[#c9a959] text-black font-semibold"
                                : "bg-[#f9fafb] text-[#374151] border border-[rgba(11,20,55,0.10)]"
                        }`}
                    >
                        {c.name} <span className="opacity-60">({c.count})</span>
                    </Link>
                ))}
            </div>

            <div className="mt-5 flex items-center gap-2 flex-wrap">
                <span className="text-xs uppercase tracking-widest text-[#6b7280] flex items-center gap-1">
                    <Filter size={12} /> Sort by
                </span>
                {[
                    ["featured", "Featured"],
                    ["discount", "Highest discount"],
                    ["price_low", "Price low"],
                    ["price_high", "Price high"],
                ].map(([k, l]) => (
                    <button
                        key={k}
                        onClick={() => setParams({ sort: k })}
                        className={`px-3 py-1 rounded-full text-xs ${
                            sort === k ? "bg-white text-black font-semibold" : "bg-[#f9fafb] text-[#374151] border border-[rgba(11,20,55,0.10)]"
                        }`}
                    >
                        {l}
                    </button>
                ))}
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 mt-6">
                {busy && Array.from({ length: 10 }).map((_, i) => (
                    <div key={i} className="aspect-[4/5] fx-card animate-pulse bg-[#f9fafb]" />
                ))}
                {!busy && items.map((r) => <VoucherCard key={r.id} r={r} />)}
            </div>
            {!busy && items.length === 0 && (
                <div className="fx-card p-10 text-center text-[#6b7280] mt-6">No deals found in this category.</div>
            )}
        </div>
    );
}
